import { TreePalm } from "@phosphor-icons/react";
import { useTranslate } from "@refinedev/core";
import { ConfigProvider, Flex, Empty as AntEmpty, EmptyProps } from "antd";
import { useAntTheme } from "hooks/useAntTheme";
import { radius } from "@libertify/ui";

export const Empty = ({
  image,
  description,
  children,
  size = 200,
  ...rest
}: EmptyProps & { size?: number }) => {
  const { theme } = useAntTheme();
  const t = useTranslate();
  return (
    <ConfigProvider
      theme={{
        components: {
          Empty: {
            fontSize: 20,
            // gives 85px for 200px size
            controlHeightLG: Math.round(size * 0.425),
          },
        },
      }}
    >
      <AntEmpty
        image={
          <Flex justify="center" style={{ width: "100%" }}>
            <Flex
              style={{
                backgroundColor: theme.colorPrimaryBorder,
                height: size,
                width: size,
                borderRadius: radius.circle,
                color: theme.colorText,
              }}
            >
              {image ? image : <TreePalm size={100} />}
            </Flex>
          </Flex>
        }
        description={
          description ? description : t("src.components.Empty.noResultsFound")
        }
        {...rest}
      >
        {children}
      </AntEmpty>
    </ConfigProvider>
  );
};
